export const SONG_FEATURES = Object.freeze([
  {
    Title: "Enter Sandman",
    Original_Title: "Enter Sandman",
    Artists: "Alessia Cara, The Warning",
    Danceability: 0.537,
    Energy: 0.636,
    Speechiness: 0.0279,
    Acousticness: 0.000172,
    Instrumentalness: 0.000576,
    Liveness: 0.138,
    Valence: 0.162,
    Key: 4,
    Mode: 0,
    Tempo: 130.997,
    Loudness: -9.164,
    Is_Original: false,
  },
  {
    Title: "Enter Sandman",
    Original_Title: "Enter Sandman",
    Artists: "Mac DeMarco",
    Danceability: 0.577,
    Energy: 0.796,
    Speechiness: 0.0356,
    Acousticness: 0.0000843,
    Instrumentalness: 0.0189,
    Liveness: 0.107,
    Valence: 0.427,
    Key: 0,
    Mode: 1,
    Tempo: 126.721,
    Loudness: -5.486,
    Is_Original: false,
  },
  {
    Title: "Enter Sandman",
    Original_Title: "Enter Sandman",
    Artists: "Ghost",
    Danceability: 0.356,
    Energy: 0.708,
    Speechiness: 0.039,
    Acousticness: 0.00253,
    Instrumentalness: 0.000102,
    Liveness: 0.0951,
    Valence: 0.378,
    Key: 2,
    Mode: 1,
    Tempo: 123.035,
    Loudness: -6.52,
    Is_Original: false,
  },
  {
    Title: "Enter Sandman",
    Original_Title: "Enter Sandman",
    Artists: "Juanes",
    Danceability: 0.775,
    Energy: 0.535,
    Speechiness: 0.0434,
    Acousticness: 0.00118,
    Instrumentalness: 0.0000569,
    Liveness: 0.0739,
    Valence: 0.655,
    Key: 2,
    Mode: 1,
    Tempo: 123.018,
    Loudness: -6.613,
    Is_Original: false,
  },
  {
    Title: "Enter Sandman",
    Original_Title: "Enter Sandman",
    Artists: "Rina Sawayama",
    Danceability: 0.519,
    Energy: 0.954,
    Speechiness: 0.113,
    Acousticness: 0.00122,
    Instrumentalness: 0.00015,
    Liveness: 0.0847,
    Valence: 0.302,
    Key: 9,
    Mode: 0,
    Tempo: 124.695,
    Loudness: -4.413,
    Is_Original: false,
  },
  {
    Title: "Enter Sandman",
    Original_Title: "Enter Sandman",
    Artists: "Weezer",
    Danceability: 0.533,
    Energy: 0.846,
    Speechiness: 0.0499,
    Acousticness: 0.00105,
    Instrumentalness: 0.0114,
    Liveness: 0.145,
    Valence: 0.446,
    Key: 5,
    Mode: 0,
    Tempo: 124.2,
    Loudness: -4.934,
    Is_Original: false,
  },
  {
    Title: "Sad But True (Live)",
    Original_Title: "Sad But True",
    Artists: "Sam Fender",
    Danceability: 0.536,
    Energy: 0.269,
    Speechiness: 0.0261,
    Acousticness: 0.698,
    Instrumentalness: 0,
    Liveness: 0.0681,
    Valence: 0.205,
    Key: 3,
    Mode: 0,
    Tempo: 65.946,
    Loudness: -7.055,
    Is_Original: false,
  },
  {
    Title: "Sad But True",
    Original_Title: "Sad But True",
    Artists: "Jason Isbell and the 400 Unit",
    Danceability: 0.369,
    Energy: 0.887,
    Speechiness: 0.0631,
    Acousticness: 0.0113,
    Instrumentalness: 0.0359,
    Liveness: 0.232,
    Valence: 0.49,
    Key: 7,
    Mode: 1,
    Tempo: 105.867,
    Loudness: -4.582,
    Is_Original: false,
  },
  {
    Title: "Sad But True",
    Original_Title: "Sad But True",
    Artists: "Mexican Institute Of Sound, La Perla, Gera MX, Metallica",
    Danceability: 0.578,
    Energy: 0.818,
    Speechiness: 0.147,
    Acousticness: 0.00215,
    Instrumentalness: 0.0162,
    Liveness: 0.335,
    Valence: 0.451,
    Key: 2,
    Mode: 1,
    Tempo: 178.083,
    Loudness: -5.119,
    Is_Original: false,
  },
  {
    Title: "Sad But True",
    Original_Title: "Sad But True",
    Artists: "Royal Blood",
    Danceability: 0.477,
    Energy: 0.872,
    Speechiness: 0.034,
    Acousticness: 0.0000875,
    Instrumentalness: 0.00323,
    Liveness: 0.0756,
    Valence: 0.631,
    Key: 7,
    Mode: 1,
    Tempo: 89.092,
    Loudness: -4.436,
    Is_Original: false,
  },
  {
    Title: "Sad But True",
    Original_Title: "Sad But True",
    Artists: "St. Vincent",
    Danceability: 0.479,
    Energy: 0.733,
    Speechiness: 0.0871,
    Acousticness: 0.000589,
    Instrumentalness: 0.000432,
    Liveness: 0.283,
    Valence: 0.508,
    Key: 9,
    Mode: 0,
    Tempo: 179.995,
    Loudness: -8.539,
    Is_Original: false,
  },
  {
    Title: "Sad But True",
    Original_Title: "Sad But True",
    Artists: "White Reaper",
    Danceability: 0.48,
    Energy: 0.846,
    Speechiness: 0.0356,
    Acousticness: 0.00011,
    Instrumentalness: 0.00442,
    Liveness: 0.37,
    Valence: 0.415,
    Key: 7,
    Mode: 1,
    Tempo: 92.203,
    Loudness: -4.975,
    Is_Original: false,
  },
  {
    Title: "Sad But True",
    Original_Title: "Sad But True",
    Artists: "YB",
    Danceability: 0.476,
    Energy: 0.932,
    Speechiness: 0.0364,
    Acousticness: 0.0000478,
    Instrumentalness: 0.155,
    Liveness: 0.0721,
    Valence: 0.609,
    Key: 0,
    Mode: 1,
    Tempo: 98.002,
    Loudness: -4.233,
    Is_Original: false,
  },
  {
    Title: "Holier Than Thou",
    Original_Title: "Holier Than Thou",
    Artists: "Biffy Clyro",
    Danceability: 0.471,
    Energy: 0.735,
    Speechiness: 0.0375,
    Acousticness: 0.0039,
    Instrumentalness: 0.000523,
    Liveness: 0.165,
    Valence: 0.0598,
    Key: 6,
    Mode: 1,
    Tempo: 144.058,
    Loudness: -8.33,
    Is_Original: false,
  },
  {
    Title: "Holier Than Thou",
    Original_Title: "Holier Than Thou",
    Artists: "The Chats",
    Danceability: 0.156,
    Energy: 0.987,
    Speechiness: 0.156,
    Acousticness: 0.00247,
    Instrumentalness: 0.293,
    Liveness: 0.12,
    Valence: 0.0395,
    Key: 9,
    Mode: 1,
    Tempo: 184.117,
    Loudness: -4.354,
    Is_Original: false,
  },
  {
    Title: "Holier Than Thou",
    Original_Title: "Holier Than Thou",
    Artists: "OFF!",
    Danceability: 0.224,
    Energy: 0.995,
    Speechiness: 0.263,
    Acousticness: 0.0000231,
    Instrumentalness: 0.601,
    Liveness: 0.0758,
    Valence: 0.143,
    Key: 4,
    Mode: 1,
    Tempo: 176.374,
    Loudness: -5.408,
    Is_Original: false,
  },
  {
    Title: "Holier Than Thou",
    Original_Title: "Holier Than Thou",
    Artists: "PUP",
    Danceability: 0.407,
    Energy: 0.944,
    Speechiness: 0.0397,
    Acousticness: 0.000067,
    Instrumentalness: 0.0204,
    Liveness: 0.334,
    Valence: 0.614,
    Key: 1,
    Mode: 0,
    Tempo: 170.953,
    Loudness: -5.257,
    Is_Original: false,
  },
  {
    Title: "Holier Than Thou",
    Original_Title: "Holier Than Thou",
    Artists: "Corey Taylor",
    Danceability: 0.478,
    Energy: 0.987,
    Speechiness: 0.0685,
    Acousticness: 0.00144,
    Instrumentalness: 0.00607,
    Liveness: 0.837,
    Valence: 0.547,
    Key: 1,
    Mode: 0,
    Tempo: 172.065,
    Loudness: -3.528,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "Cage The Elephant",
    Danceability: 0.576,
    Energy: 0.634,
    Speechiness: 0.0311,
    Acousticness: 0.0563,
    Instrumentalness: 0.163,
    Liveness: 0.136,
    Valence: 0.189,
    Key: 7,
    Mode: 1,
    Tempo: 143.989,
    Loudness: -8.99,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "Vishal Dadlani, DIVINE, Shor Police, Metallica",
    Danceability: 0.591,
    Energy: 0.544,
    Speechiness: 0.0383,
    Acousticness: 0.142,
    Instrumentalness: 0,
    Liveness: 0.152,
    Valence: 0.449,
    Key: 6,
    Mode: 0,
    Tempo: 140.016,
    Loudness: -8.901,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "Diet Cig",
    Danceability: 0.286,
    Energy: 0.81,
    Speechiness: 0.0569,
    Acousticness: 0.00362,
    Instrumentalness: 0.102,
    Liveness: 0.211,
    Valence: 0.247,
    Key: 0,
    Mode: 1,
    Tempo: 138.742,
    Loudness: -5.625,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "Flatbush Zombies, DJ Scratch, Metallica",
    Danceability: 0.589,
    Energy: 0.893,
    Speechiness: 0.079,
    Acousticness: 0.00809,
    Instrumentalness: 0.000188,
    Liveness: 0.166,
    Valence: 0.366,
    Key: 7,
    Mode: 1,
    Tempo: 97.994,
    Loudness: -6.342,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "Ha*Ash",
    Danceability: 0.539,
    Energy: 0.483,
    Speechiness: 0.0352,
    Acousticness: 0.489,
    Instrumentalness: 0,
    Liveness: 0.101,
    Valence: 0.23,
    Key: 7,
    Mode: 0,
    Tempo: 148.222,
    Loudness: -6.921,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "José Madero",
    Danceability: 0.551,
    Energy: 0.634,
    Speechiness: 0.0332,
    Acousticness: 0.355,
    Instrumentalness: 0.0000017,
    Liveness: 0.0896,
    Valence: 0.278,
    Key: 8,
    Mode: 0,
    Tempo: 129.909,
    Loudness: -6.895,
    Is_Original: false,
  },
  {
    Title: "The Unforgiven",
    Original_Title: "The Unforgiven",
    Artists: "Moses Sumney",
    Danceability: 0.393,
    Energy: 0.274,
    Speechiness: 0.0541,
    Acousticness: 0.802,
    Instrumentalness: 0.00581,
    Liveness: 0.114,
    Valence: 0.105,
    Key: 3,
    Mode: 0,
    Tempo: 139.159,
    Loudness: -15.417,
    Is_Original: false,
  },
  {
    Title: "Wherever I May Roam",
    Original_Title: "Wherever I May Roam",
    Artists: "J Balvin, Metallica",
    Danceability: 0.685,
    Energy: 0.738,
    Speechiness: 0.0329,
    Acousticness: 0.0024,
    Instrumentalness: 0,
    Liveness: 0.386,
    Valence: 0.199,
    Key: 5,
    Mode: 1,
    Tempo: 129.002,
    Loudness: -5.893,
    Is_Original: false,
  },
  {
    Title: "Wherever I May Roam",
    Original_Title: "Wherever I May Roam",
    Artists: "Chase & Status, BackRoad Gee, Metallica",
    Danceability: 0.626,
    Energy: 0.734,
    Speechiness: 0.376,
    Acousticness: 0.233,
    Instrumentalness: 0.0000262,
    Liveness: 0.0645,
    Valence: 0.347,
    Key: 9,
    Mode: 1,
    Tempo: 139.726,
    Loudness: -6.456,
    Is_Original: false,
  },
  {
    Title: "Wherever I May Roam",
    Original_Title: "Wherever I May Roam",
    Artists: "The Neptunes, Metallica",
    Danceability: 0.703,
    Energy: 0.943,
    Speechiness: 0.0632,
    Acousticness: 0.0151,
    Instrumentalness: 0.0115,
    Liveness: 0.095,
    Valence: 0.518,
    Key: 0,
    Mode: 1,
    Tempo: 132.003,
    Loudness: -7.265,
    Is_Original: false,
  },
  {
    Title: "Wherever I May Roam",
    Original_Title: "Wherever I May Roam",
    Artists: "Jon Pardi",
    Danceability: 0.432,
    Energy: 0.905,
    Speechiness: 0.0618,
    Acousticness: 0.0014,
    Instrumentalness: 0.00918,
    Liveness: 0.389,
    Valence: 0.237,
    Key: 2,
    Mode: 1,
    Tempo: 133.827,
    Loudness: -3.214,
    Is_Original: false,
  },
  {
    Title: "Don't Tread on Else Matters",
    Original_Title: "Don't Tread on Me",
    Artists: "SebastiAn, Metallica",
    Danceability: 0.391,
    Energy: 0.621,
    Speechiness: 0.179,
    Acousticness: 0.0101,
    Instrumentalness: 0.171,
    Liveness: 0.0911,
    Valence: 0.512,
    Key: 9,
    Mode: 1,
    Tempo: 161.879,
    Loudness: -5.593,
    Is_Original: false,
  },
  {
    Title: "Don't Tread on Me",
    Original_Title: "Don't Tread on Me",
    Artists: "Portugal. The Man, Aaron Beam",
    Danceability: 0.355,
    Energy: 0.878,
    Speechiness: 0.148,
    Acousticness: 0.00325,
    Instrumentalness: 0.0164,
    Liveness: 0.274,
    Valence: 0.158,
    Key: 2,
    Mode: 1,
    Tempo: 105.962,
    Loudness: -5.987,
    Is_Original: false,
  },
  {
    Title: "Don't Tread on Me",
    Original_Title: "Don't Tread on Me",
    Artists: "Volbeat",
    Danceability: 0.565,
    Energy: 0.934,
    Speechiness: 0.0488,
    Acousticness: 0.0000257,
    Instrumentalness: 0.00103,
    Liveness: 0.187,
    Valence: 0.562,
    Key: 0,
    Mode: 1,
    Tempo: 125.027,
    Loudness: -6.022,
    Is_Original: false,
  },
  {
    Title: "Through the Never",
    Original_Title: "Through the Never",
    Artists: "The HU",
    Danceability: 0.478,
    Energy: 0.91,
    Speechiness: 0.084,
    Acousticness: 0.000742,
    Instrumentalness: 0.2,
    Liveness: 0.0955,
    Valence: 0.369,
    Key: 1,
    Mode: 1,
    Tempo: 94.336,
    Loudness: -7.019,
    Is_Original: false,
  },
  {
    Title: "Through the Never",
    Original_Title: "Through the Never",
    Artists: "Tomi Owó",
    Danceability: 0.439,
    Energy: 0.789,
    Speechiness: 0.0998,
    Acousticness: 0.0366,
    Instrumentalness: 0.000101,
    Liveness: 0.0723,
    Valence: 0.761,
    Key: 0,
    Mode: 1,
    Tempo: 85.216,
    Loudness: -7.316,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Phoebe Bridgers",
    Danceability: 0.355,
    Energy: 0.317,
    Speechiness: 0.0325,
    Acousticness: 0.885,
    Instrumentalness: 0.00679,
    Liveness: 0.111,
    Valence: 0.529,
    Key: 11,
    Mode: 0,
    Tempo: 151.984,
    Loudness: -14.056,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Miley Cyrus, WATT, Elton John, Yo-Yo Ma, Robert Trujillo, Chad Smith",
    Danceability: 0.444,
    Energy: 0.66,
    Speechiness: 0.0297,
    Acousticness: 0.00551,
    Instrumentalness: 0.0000192,
    Liveness: 0.115,
    Valence: 0.144,
    Key: 4,
    Mode: 0,
    Tempo: 142.519,
    Loudness: -5.658,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Dave Gahan",
    Danceability: 0.17,
    Energy: 0.144,
    Speechiness: 0.037,
    Acousticness: 0.926,
    Instrumentalness: 0.251,
    Liveness: 0.0846,
    Valence: 0.124,
    Key: 4,
    Mode: 0,
    Tempo: 75.971,
    Loudness: -18.95,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Mickey Guyton",
    Danceability: 0.335,
    Energy: 0.546,
    Speechiness: 0.0432,
    Acousticness: 0.0343,
    Instrumentalness: 0.0000485,
    Liveness: 0.0811,
    Valence: 0.195,
    Key: 9,
    Mode: 0,
    Tempo: 139.318,
    Loudness: -8.223,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Dermot Kennedy",
    Danceability: 0.494,
    Energy: 0.116,
    Speechiness: 0.0332,
    Acousticness: 0.951,
    Instrumentalness: 0.00000151,
    Liveness: 0.0895,
    Valence: 0.152,
    Key: 4,
    Mode: 0,
    Tempo: 72.543,
    Loudness: -10.829,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Mon Laferte",
    Danceability: 0.45,
    Energy: 0.617,
    Speechiness: 0.0302,
    Acousticness: 0.542,
    Instrumentalness: 0.0799,
    Liveness: 0.101,
    Valence: 0.153,
    Key: 9,
    Mode: 0,
    Tempo: 151.096,
    Loudness: -7.586,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Igor Levit",
    Danceability: 0.416,
    Energy: 0.214,
    Speechiness: 0.0379,
    Acousticness: 0.988,
    Instrumentalness: 0.908,
    Liveness: 0.0526,
    Valence: 0.135,
    Key: 4,
    Mode: 0,
    Tempo: 72.078,
    Loudness: -15.543,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "My Morning Jacket",
    Danceability: 0.641,
    Energy: 0.642,
    Speechiness: 0.0351,
    Acousticness: 0.239,
    Instrumentalness: 0.0000608,
    Liveness: 0.209,
    Valence: 0.635,
    Key: 4,
    Mode: 1,
    Tempo: 123.053,
    Loudness: -6.027,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "PG Roxette",
    Danceability: 0.269,
    Energy: 0.52,
    Speechiness: 0.0375,
    Acousticness: 0.0554,
    Instrumentalness: 0.0186,
    Liveness: 0.123,
    Valence: 0.232,
    Key: 10,
    Mode: 0,
    Tempo: 154.938,
    Loudness: -8.541,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Darius Rucker",
    Danceability: 0.384,
    Energy: 0.414,
    Speechiness: 0.0279,
    Acousticness: 0.0817,
    Instrumentalness: 0.00811,
    Liveness: 0.0955,
    Valence: 0.116,
    Key: 4,
    Mode: 0,
    Tempo: 142.509,
    Loudness: -8.07,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "Chris Stapleton",
    Danceability: 0.326,
    Energy: 0.635,
    Speechiness: 0.0322,
    Acousticness: 0.0207,
    Instrumentalness: 0.425,
    Liveness: 0.106,
    Valence: 0.26,
    Key: 0,
    Mode: 1,
    Tempo: 131.533,
    Loudness: -7.122,
    Is_Original: false,
  },
  {
    Title: "Nothing Else Matters",
    Original_Title: "Nothing Else Matters",
    Artists: "TRESOR",
    Danceability: 0.597,
    Energy: 0.261,
    Speechiness: 0.0299,
    Acousticness: 0.27,
    Instrumentalness: 0.00439,
    Liveness: 0.11,
    Valence: 0.0463,
    Key: 6,
    Mode: 0,
    Tempo: 139.859,
    Loudness: -13.189,
    Is_Original: false,
  },
  {
    Title: "Of Wolf and Man",
    Original_Title: "Of Wolf and Man",
    Artists: "Goodnight, Texas",
    Danceability: 0.507,
    Energy: 0.417,
    Speechiness: 0.0311,
    Acousticness: 0.0435,
    Instrumentalness: 0.0000455,
    Liveness: 0.1,
    Valence: 0.351,
    Key: 5,
    Mode: 1,
    Tempo: 116.026,
    Loudness: -12.376,
    Is_Original: false,
  },
  {
    Title: "The God That Failed",
    Original_Title: "The God That Failed",
    Artists: "IDLES",
    Danceability: 0.329,
    Energy: 0.868,
    Speechiness: 0.0559,
    Acousticness: 0.0000142,
    Instrumentalness: 0.00000685,
    Liveness: 0.188,
    Valence: 0.338,
    Key: 11,
    Mode: 1,
    Tempo: 111.425,
    Loudness: -6.37,
    Is_Original: false,
  },
  {
    Title: "The God That Failed",
    Original_Title: "The God That Failed",
    Artists: "Imelda May",
    Danceability: 0.459,
    Energy: 0.764,
    Speechiness: 0.0355,
    Acousticness: 0.0285,
    Instrumentalness: 0.00193,
    Liveness: 0.113,
    Valence: 0.353,
    Key: 11,
    Mode: 0,
    Tempo: 162.771,
    Loudness: -5.749,
    Is_Original: false,
  },
  {
    Title: "My Friend of Misery",
    Original_Title: "My Friend of Misery",
    Artists: "Cherry Glazerr",
    Danceability: 0.588,
    Energy: 0.865,
    Speechiness: 0.0628,
    Acousticness: 0.0648,
    Instrumentalness: 0.000091,
    Liveness: 0.0825,
    Valence: 0.365,
    Key: 9,
    Mode: 1,
    Tempo: 119.985,
    Loudness: -5.798,
    Is_Original: false,
  },
  {
    Title: "My Friend of Misery",
    Original_Title: "My Friend of Misery",
    Artists: "Izïa",
    Danceability: 0.621,
    Energy: 0.799,
    Speechiness: 0.0337,
    Acousticness: 0.00216,
    Instrumentalness: 0.00434,
    Liveness: 0.102,
    Valence: 0.238,
    Key: 2,
    Mode: 1,
    Tempo: 130.012,
    Loudness: -5.349,
    Is_Original: false,
  },
  {
    Title: "My Friend of Misery",
    Original_Title: "My Friend of Misery",
    Artists: "Kamasi Washington",
    Danceability: 0.376,
    Energy: 0.802,
    Speechiness: 0.0809,
    Acousticness: 0.016,
    Instrumentalness: 0.665,
    Liveness: 0.0564,
    Valence: 0.454,
    Key: 6,
    Mode: 1,
    Tempo: 90.408,
    Loudness: -7.809,
    Is_Original: false,
  },
  {
    Title: "The Struggle Within",
    Original_Title: "The Struggle Within",
    Artists: "Rodrigo y Gabriela",
    Danceability: 0.801,
    Energy: 0.957,
    Speechiness: 0.0742,
    Acousticness: 0.0936,
    Instrumentalness: 0.797,
    Liveness: 0.0572,
    Valence: 0.54,
    Key: 6,
    Mode: 0,
    Tempo: 97.468,
    Loudness: -5.686,
    Is_Original: false,
  },
  {
    Title: "Enter Sandman (Remastered)",
    Original_Title: "Enter Sandman",
    Artists: "Metallica",
    Danceability: 0.566,
    Energy: 0.834,
    Speechiness: 0.0298,
    Acousticness: 0.00277,
    Instrumentalness: 0.008,
    Liveness: 0.0625,
    Valence: 0.621,
    Key: 6,
    Mode: 0,
    Tempo: 123.296,
    Loudness: -8.412,
    Is_Original: true,
  },
  {
    Title: "Sad But True (Remastered)",
    Original_Title: "Sad But True",
    Artists: "Metallica",
    Danceability: 0.624,
    Energy: 0.876,
    Speechiness: 0.0342,
    Acousticness: 0.000926,
    Instrumentalness: 0.00164,
    Liveness: 0.0561,
    Valence: 0.453,
    Key: 7,
    Mode: 1,
    Tempo: 89.24,
    Loudness: -6.005,
    Is_Original: true,
  },
  {
    Title: "Holier Than Thou (Remastered)",
    Original_Title: "Holier Than Thou",
    Artists: "Metallica",
    Danceability: 0.458,
    Energy: 0.97,
    Speechiness: 0.0408,
    Acousticness: 0.00178,
    Instrumentalness: 0.272,
    Liveness: 0.0826,
    Valence: 0.342,
    Key: 4,
    Mode: 0,
    Tempo: 172.123,
    Loudness: -5.915,
    Is_Original: true,
  },
  {
    Title: "The Unforgiven (Remastered)",
    Original_Title: "The Unforgiven",
    Artists: "Metallica",
    Danceability: 0.531,
    Energy: 0.583,
    Speechiness: 0.0256,
    Acousticness: 0.0184,
    Instrumentalness: 0.00624,
    Liveness: 0.255,
    Valence: 0.207,
    Key: 7,
    Mode: 1,
    Tempo: 139.503,
    Loudness: -9.47,
    Is_Original: true,
  },
  {
    Title: "Wherever I May Roam (Remastered)",
    Original_Title: "Wherever I May Roam",
    Artists: "Metallica",
    Danceability: 0.539,
    Energy: 0.834,
    Speechiness: 0.0364,
    Acousticness: 0.000646,
    Instrumentalness: 0.000516,
    Liveness: 0.119,
    Valence: 0.339,
    Key: 9,
    Mode: 0,
    Tempo: 131.383,
    Loudness: -7.459,
    Is_Original: true,
  },
  {
    Title: "Don't Tread on Me (Remastered)",
    Original_Title: "Don't Tread on Me",
    Artists: "Metallica",
    Danceability: 0.655,
    Energy: 0.882,
    Speechiness: 0.0491,
    Acousticness: 0.0068,
    Instrumentalness: 0.00297,
    Liveness: 0.259,
    Valence: 0.678,
    Key: 4,
    Mode: 0,
    Tempo: 108.019,
    Loudness: -6.471,
    Is_Original: true,
  },
  {
    Title: "Through the Never (Remastered)",
    Original_Title: "Through the Never",
    Artists: "Metallica",
    Danceability: 0.384,
    Energy: 0.95,
    Speechiness: 0.0546,
    Acousticness: 0.0109,
    Instrumentalness: 0.351,
    Liveness: 0.139,
    Valence: 0.482,
    Key: 4,
    Mode: 0,
    Tempo: 94.266,
    Loudness: -5.943,
    Is_Original: true,
  },
  {
    Title: "Nothing Else Matters (Remastered)",
    Original_Title: "Nothing Else Matters",
    Artists: "Metallica",
    Danceability: 0.547,
    Energy: 0.394,
    Speechiness: 0.0262,
    Acousticness: 0.0522,
    Instrumentalness: 0.0000064,
    Liveness: 0.0795,
    Valence: 0.17,
    Key: 4,
    Mode: 0,
    Tempo: 142.37,
    Loudness: -9.793,
    Is_Original: true,
  },
  {
    Title: "Of Wolf and Man (Remastered)",
    Original_Title: "Of Wolf and Man",
    Artists: "Metallica",
    Danceability: 0.605,
    Energy: 0.792,
    Speechiness: 0.0366,
    Acousticness: 0.000988,
    Instrumentalness: 0.0382,
    Liveness: 0.0852,
    Valence: 0.47,
    Key: 5,
    Mode: 1,
    Tempo: 121.768,
    Loudness: -6.87,
    Is_Original: true,
  },
  {
    Title: "The God That Failed (Remastered)",
    Original_Title: "The God That Failed",
    Artists: "Metallica",
    Danceability: 0.551,
    Energy: 0.813,
    Speechiness: 0.0363,
    Acousticness: 0.000451,
    Instrumentalness: 0.000123,
    Liveness: 0.174,
    Valence: 0.431,
    Key: 8,
    Mode: 1,
    Tempo: 83.046,
    Loudness: -6.406,
    Is_Original: true,
  },
  {
    Title: "My Friend of Misery (Remastered)",
    Original_Title: "My Friend of Misery",
    Artists: "Metallica",
    Danceability: 0.567,
    Energy: 0.855,
    Speechiness: 0.0355,
    Acousticness: 0.000235,
    Instrumentalness: 0.00714,
    Liveness: 0.1,
    Valence: 0.329,
    Key: 9,
    Mode: 0,
    Tempo: 119.513,
    Loudness: -7.623,
    Is_Original: true,
  },
  {
    Title: "The Struggle Within (Remastered)",
    Original_Title: "The Struggle Within",
    Artists: "Metallica",
    Danceability: 0.466,
    Energy: 0.944,
    Speechiness: 0.0514,
    Acousticness: 0.0014,
    Instrumentalness: 0.0289,
    Liveness: 0.236,
    Valence: 0.505,
    Key: 0,
    Mode: 1,
    Tempo: 98.766,
    Loudness: -6.498,
    Is_Original: true,
  }
]);